import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUnsubscribeMyContentCommentSubscriptions } from 'actions/contentCommentSubscriptions';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function UnsubscribeConfirmationModal(_ref) {
  var closeModal = _ref.closeModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUnsubscribeMyCont = useUnsubscribeMyContentCommentSubscriptions({
      onSuccess: closeModal
    }),
    unsubscribeMyContentCommentSubscriptions = _useUnsubscribeMyCont.unsubscribeMyContentCommentSubscriptions,
    isPending = _useUnsubscribeMyCont.isPending;
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t('modal_unsubscribe_content_comments_title'),
    body: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: t('modal_unsubscribe_content_comments_body_1')
      }), /*#__PURE__*/_jsx("p", {
        children: t('modal_unsubscribe_content_comments_body_2')
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: closeModal,
      isDisabled: isPending
    }, {
      label: t('actions_confirm'),
      onClick: function onClick() {
        return unsubscribeMyContentCommentSubscriptions();
      },
      variant: 'primary',
      isDisabled: isPending
    }],
    onClose: closeModal
  });
}
export default UnsubscribeConfirmationModal;